import { render } from "./ReportJournal.vue?vue&type=template&id=4bec1638&ts=true"
import script from "./ReportJournal.vue?vue&type=script&lang=ts"
export * from "./ReportJournal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__